import { render, staticRenderFns } from "./BaseMapButton.vue?vue&type=template&id=00bda0b6&scoped=true"
import script from "./BaseMapButton.vue?vue&type=script&lang=js"
export * from "./BaseMapButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bda0b6",
  null
  
)

export default component.exports